<div class="pre-login">
    <div class="pre-login-col-1 h-100">
        <left-panel-onboarding></left-panel-onboarding>
    </div>
    <div class="pre-login-col-2">
    </div>
    <div class="pre-login-col-3">
        <div class="onboarding-canvas">
            <grid-row class="mt-10">
                <grid-col col="8">
                    <div class="font-400 font-size-20px line-h-25">
                        {{ "Nextlets" | translate }}
                    </div>
                    <div class="font-400 font-size-14px color-base-500 mt-10 line-h-20">
                        {{ "Strongpasswordensures" | translate }}
                    </div>
                </grid-col>
            </grid-row>
            <!-- <form [formGroup]="createpassForm">
                <div class="form-group password-eye mt-30">
                    <label class="no-mark">
                        {{ "createpassword" | translate }}
                    </label>
                    <input type="password" showPassword [(ngModel)]="createpass1" formControlName="passwordCreateform"
                        placeholder="Please enter">
                    <ng-container *ngFor="let validation of errorKey.validation_messages.createpassword1">
                        <span class="error-label" *ngIf="createpassForm.get('passwordCreateform')?.hasError(validation.type) 
                   && createpassForm.get('passwordCreateform')?.touched">
                            {{ getMessage(validation.key,'createpassword1') }}
                        </span>
                    </ng-container>
                </div>
                <div class="form-group password-eye mt-30">
                    <label class="no-mark">
                        {{ "reenterpassword" | translate }}
                    </label>
                    <input type="password" showPassword placeholder="Please enter">

                </div>
            </form> -->
            <form [formGroup]="createpassForm">
                <!-- <div class="form-group password-eye mt-30">
                    <label class="no-mark">
                        {{ "createpassword" | translate }}
                    </label>
                    <input type="password" showPassword [(ngModel)]="createpass1" formControlName="passwordCreateform"
                        placeholder="Please enter">
                    <ng-container *ngFor="let validation of errorKey.validation_messages.createpassword1">
                        <span class="error-label" *ngIf="createpassForm.get('passwordCreateform')?.hasError(validation.type) 
        && createpassForm.get('passwordCreateform')?.touched">
                            {{ getMessage(validation.key,'createpassword1') }}
                        </span>
                    </ng-container>
                </div> -->
                <div class="form-group password-eye mt-30">
                    <label class="no-mark">
                        {{ "createpassword" | translate }}
                    </label>
                    <input type="password" showPassword [(ngModel)]="createpass1" formControlName="passwordCreateform"
                        placeholder="Please enter" (input)="onPasswordInput(createpass1)">

                    <ng-container *ngFor="let validation of errorKey.validation_messages.createpassword1">
                        <span class="error-label" *ngIf="createpassForm.get('passwordCreateform')?.hasError(validation.type) 
        && createpassForm.get('passwordCreateform')?.touched">
                            {{ getMessage(validation.key,'createpassword1') }}
                        </span>
                    </ng-container>
                </div>

                <div class="form-group password-eye mt-30">
                    <label class="no-mark">
                        {{ "reenterpassword" | translate }}
                    </label>
                    <input type="password" [(ngModel)]="confirmPass" showPassword formControlName="confirmPassword" placeholder="Please enter">

                    <span class="error-label" *ngIf="createpassForm.hasError('passwordMismatch') 
      && createpassForm.get('confirmPassword')?.touched">
                        {{ getMessage('PasswordMismatch','createpassword1') }}
                    </span>
                </div>
            </form>

            <div class="font-500 font-size-12px color-base-400 mt-30 letter-spacing-1" *ngIf="passwordStrengthLabel">
                {{ "passwordstrength" | translate }} :
                <strong class="font-500 weak" *ngIf="passwordStrengthLabel === 'WEAK'">
                    {{ "WEAK" | translate }}
                </strong>
                <strong class="font-500 medium" *ngIf="passwordStrengthLabel === 'MEDIUM'">
                    {{ "MEDIUM" | translate }}
                </strong>
                <strong class="font-500 strong" *ngIf="passwordStrengthLabel === 'STRONG'">
                    {{ "STRONG" | translate }}
                </strong>
            </div>


            <div class="password-stregnth mt-10">
                <div *ngFor="let block of [1,2,3,4,5,6,7,8]" class="password-stregnth-item" [ngClass]="{
                        'weak': passwordStrength > 0 && passwordStrength <= 2 && block <= passwordStrength,
                        'medium': passwordStrength > 2 && passwordStrength < 8 && block <= passwordStrength,
                        'strong': passwordStrength === 8,
                        'gray': passwordStrength === 0 || block > passwordStrength
                    }">
                </div>
            </div>
            <div class="dot-text-list">
                <ul>
                    <li>
                        {{ "Containsatleast8character" | translate }}
                    </li>
                    <li>
                        {{ "uppercaseletter" | translate }}
                    </li>
                    <li>
                        {{ "lowercaseletter" | translate }}
                    </li>
                    <li>
                        {{ "specialcharacter" | translate }}
                    </li>
                    <li>
                        {{ "Containsatleast1number" | translate }}
                    </li>
                </ul>
            </div>

            <grid-row class="justify-content-between align-item-center mt-50">
                <grid-col col="auto">
                    <div class="mt-15">
                        <button class="btn-back" (click)="back()">
                            <i class="icon-back"></i>
                        </button>
                    </div>
                </grid-col>
                <grid-col col="9">
                    <button class="btn-dft" (click)="createPassword()" [disabled]="isValid()">
                        {{ "Next" | translate }}
                    </button>
                </grid-col>
            </grid-row>
        </div>
    </div>
</div>